import { BaseModel } from "sjs-base-model";
import configuration from '../../utilities/configuration';
import * as EffectUtility from "../../utilities/EffectUtility";

export async function sendContactRequest(details) {
    const endpoint = configuration.apiServer + configuration.apiMessagePath + "/contactUs";
    return EffectUtility.postToModel(BaseModel, endpoint, details);
}

export async function sendSubscriptionRequest(details) {
    const endpoint = configuration.apiServer + configuration.apiMessagePath + "/subscriptionRequest";
    return EffectUtility.postToModel(BaseModel, endpoint, details);
}

export async function sendEmailToSubscriptionUser(userId, subscriptionTypeId) {
    const endpoint = configuration.apiServer + configuration.apiMessagePath + "/subscriptionEntitled";
    return EffectUtility.postToModel(BaseModel, endpoint, {userId, subscriptionTypeId}, true, true);
}